import React from 'react';

import _ from '../locale';
import { styled } from '../theme';
import renderErrors from '../utility/renderErrors';
import { Alert, FormGroup, Loading, Modal, ModalButton, ModalFooter, ModalHeader } from './';
// Do not add the inputs below to the group import because of bugs with styled
// Try to move it to the group input and google the error
// I do not remember the bug link
import H3 from './H3';
import ModalBody from './ModalBody';

export type Props = {
    className?: string;
    error?: string | null;
    style?: React.CSSProperties;
    bsSize?: 'sm' | 'lg' | 'xl';
    children?: React.ReactNode;
    title?: React.ReactNode;
    isVisible: boolean;
    isSubmitting?: boolean;
    isSaveDisabled?: boolean;
    cancelLabel?: string;
    isCancelEnabled?: boolean;
    isIgnoreEnabled?: boolean;
    ignoreLabel?: string;
    submitLabel?: string;
    cancelButtonColor?: 'primary' | 'secondary' | 'danger';
    ignoreButtonColor?: 'primary' | 'secondary' | 'danger';
    submitButtonColor?: 'primary' | 'secondary' | 'danger';
    onClose: (ev?) => void;
    onSubmit: (ev?) => void;
    onIgnore?: (ev?) => void;
};

const StyledH3 = styled(H3)({
    paddingTop: 30,
});

const SubmitModal = ({
    children,
    title,
    error,
    isVisible,
    isSubmitting,
    cancelLabel,
    isCancelEnabled = true,
    isIgnoreEnabled = false,
    ignoreLabel,
    submitLabel,
    isSaveDisabled,
    submitButtonColor = 'primary',
    cancelButtonColor = 'secondary',
    ignoreButtonColor = 'secondary',
    onClose,
    onSubmit,
    onIgnore,
    ...props
}: Props) => {
    const handleSubmit = (ev) => {
        if (ev) {
            ev.preventDefault();
        }

        onSubmit(ev);
    };

    const handleIgnore = (ev) => {
        if (ev) {
            ev.preventDefault();
        }

        onIgnore?.(ev);
    };

    const handleClose = (ev) => {
        if (ev) {
            ev.preventDefault();
        }

        onClose?.(ev);
    };

    return (
        <Modal show={isVisible} onHide={handleClose} {...props}>
            <form onSubmit={handleSubmit}>
                {title && (
                    <ModalHeader closeButton>
                        <StyledH3>{title}</StyledH3>
                    </ModalHeader>
                )}

                <ModalBody>
                    {error && (
                        <FormGroup>
                            <Alert color="error">{renderErrors(error)}</Alert>
                        </FormGroup>
                    )}

                    {children}
                </ModalBody>

                <ModalFooter>
                    {isCancelEnabled && (
                        <ModalButton color={cancelButtonColor} onClick={handleClose} type="button">
                            {cancelLabel || _('cancel_button')}
                        </ModalButton>
                    )}
                    {isIgnoreEnabled && (
                        <ModalButton color={ignoreButtonColor} onClick={handleIgnore} type="button">
                            {ignoreLabel || _('ignore_button')}
                        </ModalButton>
                    )}
                    <ModalButton color={submitButtonColor} type="submit" disabled={isSaveDisabled}>
                        {submitLabel || _('save_button')}
                    </ModalButton>
                </ModalFooter>
            </form>
            {!!isSubmitting && <Loading backdrop />}
        </Modal>
    );
};

export default SubmitModal;
